<template>
  <base-dialog-adm  :show="true"
                    title="選擇保險公司"
                    width="800"
                    btn-close-text="取消"
                    :btn-confirm="false"
                    @close="close"
                    >
                    <!-- @save="nextStepProposal" -->
                    <!-- btn-confirm-text="下一步" -->
      <base-box>
      <v-item-group mandatory>
        <v-container grid-list-md>
          <h1>保險公司</h1>
          <v-layout wrap style="margin: 5px;">
            <v-flex md6 v-for="(row,i) in srv18List" :key="'srv18List_' + i">
              <v-item>
                <v-card :class="getActiveCss('compCode' , row.compCode)"
                    class="align-center justify-center d-flex "
                    style="background-color: #fff;border: 2px solid #fff;font-size: 25px;font-weight:bolder;"
                    height="145"
                    @click.native="compClickHandler(row.compCode)">
                  <div class="text-xs-center" >{{row.compName}}</div>
                </v-card>
              </v-item>
            </v-flex>
          </v-layout>
        </v-container>
      </v-item-group>
      <hr/>
      <!-- <v-item-group mandatory v-if="showPolInsureType">
        <v-container grid-list-md>
          <h1>案件類型</h1>
          <v-layout wrap style="margin: 5px;">
              <v-flex md6>
                <v-item>
                  <v-card :class="getActiveCss('polInsureType' , 'M')"
                          class="align-center justify-center d-flex "
                          style="background-color: #fff;border: 2px solid #fff;font-size: 25px;font-weight:bolder;"
                          height="145"
                          @click.native="cardClickHandler('M')">
                      <div class="text-xs-center">行動投保</div>
                  </v-card>
                </v-item>
              </v-flex>
              <v-flex md6>
                <v-item v-if="showPolInsureType_R">
                  <v-card :class="getActiveCss('polInsureType' , 'R')"
                          class="align-center justify-center d-flex "
                          style="background-color: #fff;border: 2px solid #fff;font-size: 25px;font-weight:bolder;"
                          height="145"
                          @click.native="cardClickHandler('R')">
                      <div class="text-xs-center">遠距投保</div>
                  </v-card>
                </v-item>
              </v-flex>
          </v-layout>
        </v-container>
      </v-item-group> -->
      </base-box>
    </base-dialog-adm>
</template>
<script>
import de from 'date-fns/locale/de';
import { createNamespacedHelpers } from "vuex";
const { mapActions } = createNamespacedHelpers("common");
export default {
  name: 'choose-pol-type',
  props: {
    item: {
      type: Object
    },
    editCompCode: {//fix: SCR #89560 , 調整 [選擇要保書案件類型] 挑選視窗 UI 功能
      type: String
    },
    editInsType: {//fix: SCR #89560
      type: String
    },
  },
  data () {
    return {
      polInsureType: 'M', // 案件類型 預設M 行動投保
      compCode: null, //保險公司
      srv18List: [], //保險公司來源(SRV_18)：PRO_COMP-S01()
      mapRemoteCompCode: {}, //對應遠距投保公司代碼
      lockPolInsureType: false, //案件類型 - 是否鎖定
    }
  },
  computed: {
    showPolInsureType(){
      const {compCode} = this
      if(compCode){
        return true
      }
      return false
    },
    // showPolInsureType_R(){
    //   const {compCode ,mapRemoteCompCode} = this
    //   if(compCode){
    //     if(mapRemoteCompCode[compCode]){ //必須有遠距對應的公司代碼
    //       return true
    //     }
    //   }
    //   return false
    // },
  },
  created () {
    let vm = this
    //選擇保險公司及案件類型的輔助視窗內容，保險公司來源(SRV_18)：PRO_COMP-S01()
    //顯示「保險公司」按鈕名稱：SRV_18.COMP_NAME , 『選擇保險公司代碼』：SRV_18.COMP_CODE
    const compMap = this.$store.getters['common/allProCompanies']
    const finMap = compMap["FIN"]
    if(finMap){
      const {srv18List , mapRemoteCompCode} = vm
      Object.entries(finMap).forEach(([key, value]) => {
        const row = value[0]
        const {compName , insCompCode ,remoteCompCode} = row
        const item = {compCode:key ,compName , insCompCode ,remoteCompCode}
        // mapRemoteCompCode[item.compCode] = remoteCompCode
        srv18List.push(item) //fix: Issue #84919 , 加上保險公司資料來源
      })
    }
    //fix: SCR #89560 , 調整 [選擇要保書案件類型] 挑選視窗 UI 功能
    //設定 保險公司 與 案件類型
    if(this.editCompCode){
      this.compCode = this.editCompCode
      if(this.editInsType){
        this.lockPolInsureType = true // A.「案件類型」= SRV_4.POL_INSURE_TYPE，固定選取不能異動
        this.polInsureType = this.editInsType

      }
    }
  },
  methods: {
    ...mapActions(["fetchAdmUsers"]),
    // cardClickHandler (type) {
    //   if(this.lockPolInsureType){
    //     return
    //   }
    //   this.polInsureType = type
    // },
    compClickHandler (compCode) {
      // const {mapRemoteCompCode} = this
      // const remoteCompCode = mapRemoteCompCode[compCode]
      // if(this.editInsType === 'R' && !remoteCompCode){
        // return //若SRV_4.POL_INSURE_TYPE ='R'時，判斷SRV_18.REMOTE_COMP_CODE為空值的保險公司，反灰不能選取(表示該保險公司無遠距投保選項)
      // }
      this.compCode = compCode
      // if(!remoteCompCode){
        this.polInsureType = 'M' //案件類型固定 預設M 行動投保
      // }
    // },
    // nextStepProposal () { // 下一步(行投)
      if (this.compCode === null) {
        this.$alert('請選擇要保書保險公司')
        return
      }
      if (this.polInsureType === null) {
        this.$alert('請選擇要保書案件類型')
        return
      }
      if(this.editCompCode){//fix: SCR #89560 , 複製案件，進入此挑選的流程
        const p = {}
        p.compCode = this.compCode
        p.polInsureType = this.polInsureType
        this.$emit('copy-process' , p)
        return
      }
      if (this.polInsureType === 'M') { // 行動投保  案件類型固定為M
        const params = { notReloadAction: true, enterpoint: 'proposal' ,compCode: this.compCode, isPreview: false, polInsureType: 'M' }
        this.insStepHandler({ progClassName: 'proposal_new', methodName: '行動投保(選擇要保書類型)'})
        this.$router.push({ name: 'proposalMain', params }).catch(err => {})
      }
      else if (this.polInsureType  === 'R') { // 遠距投保  案件類型固定為R
        this.fetchAdmUsers().then((r) => {
          let admUser = r.data;
          if (admUser.remoteEduYn !== "Y") {
            this.$alert('欲進行遠距投保，請先完成遠距投保教育訓練！')
          } else {
            const params = { notReloadAction: true, enterpoint: 'proposalRemote' ,compCode: this.compCode, isPreview: false, polInsureType: 'R' }
            this.insStepHandler({ progClassName: 'proposal_new_R', methodName: '遠距投保(選擇要保書類型)'})
            this.$router.push({ name: 'proposalRemote', params }).catch(err => {})
          }
        });
      }

    },
    close () {
      this.$emit('close')
    },
    insStepHandler ({
      progClassName,
      methodName,
      stepCode,
      actionMsg,
      transCode
    }) {
      this.$store.dispatch('common/postUserAccessLog', {
          transCode: transCode,
          actionMsg: actionMsg,
          progClassName: progClassName,
          methodName: methodName,
          sysType: 'F',
          stepCode: stepCode
        })
        .then(r => {})
    },
    getActiveCss(type,val){
      let cssStr = ''
      if(type === 'compCode'){
        const {compCode,mapRemoteCompCode} = this
        const valRemoteCompCode = mapRemoteCompCode[val]
        if(this.editInsType === 'R' && !valRemoteCompCode){
          cssStr = 'disableBlock ' //若SRV_4.POL_INSURE_TYPE ='R'時，判斷SRV_18.REMOTE_COMP_CODE為空值的保險公司，反灰不能選取(表示該保險公司無遠距投保選項)
        }
        if(val === compCode){
          cssStr += 'border-active'
        }
      }else if(type === 'polInsureType'){
         if(this.lockPolInsureType){
           cssStr = 'disableBlock '
         }
         if(val === this.polInsureType){
           cssStr += 'border-active'
         }
      }
      return cssStr
    },
  }
}
</script>

<style lang="stylus" scoped>
.border-active {
  border-color: $accent-color !important;
  border-radius: 5px;
}
.disableBlock{
  background-color: rgb(241 235 235) !important;
}
h1 {
  text-align: center;
  color: #f26f28;
}
</style>
